import { Helmet } from 'react-helmet-async';
import { useCallback, useEffect, useState } from 'react';
// @mui
import { Box, Button, Card, Checkbox, Chip, CircularProgress, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, FormControl, FormControlLabel, FormGroup, Grid, InputLabel, Link, MenuItem, Select, Stack, TextField, Typography, styled } from '@mui/material';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { API, Auth, graphqlOperation } from 'aws-amplify';
import { GRAPHQL_AUTH_MODE } from '@aws-amplify/api';
import * as mutations from '../graphql/mutations';
import * as customqueries from '../graphql/customqueries';
import * as queries from '../graphql/queries';
import SnackbarAlert from 'src/components/snackbar-alert/SnackbarAlert';
import { ContentPaste } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { useAuthContext } from 'src/auth/useAuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDiscord } from '@fortawesome/free-brands-svg-icons';
import getDiscordLoginLink from 'src/utils/generateDiscordLink';
import { useSettingsContext } from 'src/components/settings';
import keyToImageUrl from 'src/utils/keyToImageUrl';
import ConnectAccountDialog from 'src/components/connect-account-dialog/ConnectAccountDialog';

// ----------------------------------------------------------------------

const StyledImg = styled('img')``;

// const sortPrizes = (prizeArray) => {
//   //Make an array sorted from lowest to highest value prize
//   return prizeArray.sort((a, b) => parseInt(a.prize.value) - parseInt(b.prize.value));
// }

const getCleanDate = (startDate, endDate) => {
  const start = {
    date: new Date(startDate).toLocaleString('en-us', { month: 'short', day: 'numeric' }),
    time: new Date(startDate).toLocaleString('en-US', { hour12: true, hour: 'numeric', minute: 'numeric', timeZoneName: 'short' })
  }

  return `${start.date} (${start.time})`
}

const stateCodes = [
  "AL",
  "AK",
  "AZ",
  "AR",
  "CA",
  "CO",
  "CT",
  "DE",
  "FL",
  "GA",
  "HI",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "ME",
  "MD",
  "MA",
  "MI",
  "MN",
  "MS",
  "MO",
  "MT",
  "NE",
  "NV",
  "NH",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "OH",
  "OK",
  "OR",
  "PA",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VT",
  "VA",
  "WA",
  "WV",
  "WI",
  "WY"
];


export default function EventPage() {
  const navigate = useNavigate();
  const { themeMode, onChangeMode } = useSettingsContext();
  const { user } = useAuthContext();
  const { id } = useParams();
  const [event, setEvent] = useState();
  const [title, setTitle] = useState('Event');
  const [game, setGame] = useState();
  const [currentUserId, setCurrentUserId] = useState();
  const [showSnackbar, setShowSnackbar] = useState({ status: false, type: 'success', message: '' });
  const [registrationButtonLoading, setRegistrationButtonLoading] = useState(true);
  const [registrationButtonText, setRegistrationButtonText] = useState('Register For Event');
  const [registrationButtonDisabled, setRegistrationButtonDisabled] = useState(true);
  const [registrationStatus, setRegistrationStatus] = useState('loading');
  const [userDetails, setUserDetails] = useState();
  const [provider, setProvider] = useState('');
  const [firstPlace, setFirstPlace] = useState();
  const [secondPlace, setSecondPlace] = useState();
  const [thirdPlace, setThirdPlace] = useState();
  const [fourthPlace, setFourthPlace] = useState();
  const [open, setOpen] = useState(false);
  const [tournaments, setTournaments] = useState();
  const [registerStep, setRegisterStep] = useState();
  const [selectedTournament, setSelectedTournament] = useState();
  const [eventType, setEventType] = useState();
  const [loading, setLoading] = useState(false);
  const [registrationQuestion, setRegistrationQuestion] = useState();
  const [registrationQuestionAnswer, setRegistrationQuestionAnswer] = useState('');
  const [userIsRegistered, setUserIsRegistered] = useState(false);
  const { pathname } = useLocation();
  const [connectAccountOpen, setConnectAccountOpen] = useState(false);
  const [noPlanOpen, setNoPlanOpen] = useState(false);

  const handleProviderRegistration = () => {
    setOpen(true);
    setRegistrationButtonDisabled(true);
    setRegistrationButtonLoading(false);
    setRegistrationButtonText('Registered');
  }

  const register = () => {
    setLoading(true)
    Auth.currentUserInfo().then((userInfo) => {
      API.post('fgnapi', '/registration', {
        body: {
          userInfo: user,
          eventRedirect: window.location.href,
          eventId: id,
          eventType,
          ...(registrationQuestionAnswer && { registrationQuestionAnswer }),
          ...((selectedTournament && selectedTournament !== '') && { tournament: selectedTournament })
        }
      }).then(response => {
        if (response.data) {
          setRegisterStep('provider');
          setOpen(true);
          setRegistrationButtonDisabled(true);
          setRegistrationButtonLoading(false);
          setRegistrationButtonText('Registered');
          setUserIsRegistered(true);
          setLoading(false)
        } else {
          setRegistrationButtonLoading(false)
          setLoading(false)
          window.location = response.replace(/"/g, '');
          // TODO: This is where we'll set everything like above, but setRegisterStep('nostripe');
          // I'll make one change one the back end to do this. Basically I just need to return something where it's currently sending the stripe URL. As long as the response doesn't have data: {}, it will fall to this.
        }
      }).catch(err => {
        console.log('Nope')
        console.log(err);
        setLoading(false);
        setRegistrationButtonLoading(false);
        setRegistrationButtonText('Register For Event');
      })
    }).catch(err => {
      console.log(err);
      setLoading(false);
      setRegistrationButtonLoading(false);
      setRegistrationButtonText('Register For Event');
    });
  }

  const handleRegisterOpen = () => {
    if (user?.provider?.useAccountNumber && user?.accountNumber && !user?.packages) {
      setNoPlanOpen(true)
    } else {
      setRegistrationButtonLoading(true);
      Auth.currentUserInfo().then((userInfo) => {
        let userStatus;
        console.log(eventType)
        if ((eventType !== 'trivia')) {
          if ((userInfo.attributes['custom:discord_id'] && userInfo.attributes['custom:discord_id'] !== '')) {
            userStatus = "discordConnected"
          } else if (!(userInfo.attributes['custom:discord_id']) && (userInfo.attributes['custom:discord_username'] && userInfo.attributes['custom:discord_username'] !== '')) {
            userStatus = "needDiscordReconnect"
          } else if (!(userInfo.attributes['custom:discord_id']) && !(userInfo.attributes['custom:discord_username'] && userInfo.attributes['custom:discord_username'] !== '')) {
            userStatus = "needDiscordConnect"
          }
        } else {
          userStatus = "discordConnected"
        }


        if (userStatus === "needDiscordConnect") {
          setRegisterStep('connectDiscord')
          setOpen(true)
          setRegistrationButtonLoading(false);
        } else if (userStatus === "needDiscordReconnect") {
          setRegisterStep('reconnectDiscord')
          setOpen(true)
          setRegistrationButtonLoading(false);
        } else if (userStatus === "discordConnected") {
          if (registrationQuestion) {
            setRegisterStep("registrationQuestion")
            setOpen(true)
            setRegistrationButtonLoading(false);
          } else {
            register();
          }
        }
      }).catch(err => console.log(err));
    }
  };

  const handleRegisterClose = () => {
    setOpen(false);
  };

  const checkRegistration = useCallback((arrayItem) => {
    console.log(arrayItem)
    return arrayItem.userProfile.id === currentUserId
  }, [currentUserId])

  const replaceImageWithUrl = async (obj) => {
    try {
      const url = await keyToImageUrl(obj.images ? obj.images : obj.game?.images);
      return {
        ...obj,
        images: url
      };
    } catch (error) {
      console.log(`Error loading image '${obj.images}':`, error);
      return {
        ...obj,
        images: obj.images ? obj.images : obj.game?.images
      };
    }
  };

  const replaceImagesWithUrls = async (imageStorageKeys) => {
    const imageUrls = await replaceImageWithUrl(imageStorageKeys);
    setEvent(imageUrls);
  };

  const getEvent = useCallback(() => {
    setEvent(null);
    API.graphql({
      query: customqueries.getEventQuery,
      variables: { id },
      authMode: GRAPHQL_AUTH_MODE.API_KEY,
    }).then((response) => {
      console.log(response);
      replaceImagesWithUrls(response.data.getEvent);
      setGame(response.data.getEvent.game);
      setTitle(response.data.getEvent.title);
      setFirstPlace(response.data.getEvent.firstPlace?.prize);
      setSecondPlace(response.data.getEvent.secondPlace?.prize);
      setThirdPlace(response.data.getEvent.thirdPlace?.prize);
      setFourthPlace(response.data.getEvent.fourthPlace?.prize);
      setTournaments(JSON.parse(response.data.getEvent.tournaments))
      setEventType(response.data.getEvent.eventType);
      setRegistrationQuestion(response.data.getEvent.registrationQuestion);
      console.log(response.data.getEvent);
    }).catch((err) => console.log(err));
  }, [id, setEvent, setGame, setTitle, setFirstPlace, setSecondPlace, setThirdPlace]);


  useEffect(() => {
    if (currentUserId && event && (event.registrations && event.registrations.items)) {
      console.log(currentUserId)
      if (event.registrations.items.length > 0) {
        const isRegistered = event.registrations.items.some(checkRegistration);
        setRegistrationButtonDisabled(isRegistered);
        setRegistrationButtonLoading(false);
        setRegistrationButtonText(isRegistered ? 'Already Registered' : 'Register For Event');
        setUserIsRegistered(isRegistered);
      } else {
        setRegistrationButtonDisabled(false);
        setRegistrationButtonLoading(false);
      }
    } else {
      setRegistrationButtonDisabled(false);
      setRegistrationButtonLoading(false);
    }
  }, [currentUserId, event, checkRegistration]);

  useEffect(() => {
    getEvent();
    Auth.currentUserInfo().then((response) => setCurrentUserId(response.attributes.sub));
  }, [getEvent])

  // const registerForEvent = () => {
  //   setRegistrationButtonLoading(true)
  //   setRegistrationButtonText('loading')
  //   setRegistrationButtonDisabled(true)
  //   const variables = {
  //     eventId: event.id,
  //     userProfileId: currentUserId
  //   }
  //   API.graphql(
  //     graphqlOperation(mutations.createEventRegistration, { input: variables })
  //   ).then((response) => {
  //     setRegistrationButtonLoading(false)
  //     setRegistrationButtonText('Registered for event!')
  //     setShowSnackbar({
  //       status: true,
  //       type: 'success',
  //       message: `You are now registered for "${event.title}"`
  //     })
  //   }).catch((err) => console.log(err))
  // }

  function checkRegistrationCutoff(cutoffDate) {
    const today = new Date(); // get current date and time
    const cutoffDateTime = new Date(cutoffDate); // create Date object for cutoff date and time
    console.log(cutoffDateTime.toISOString())
    console.log(today.toISOString());
    return cutoffDateTime.toISOString() < today.toISOString(); // return true if cutoff date and time is before now
  }


  return (
    <>
      <Helmet>
        <title> {title} | Fiber Gaming Network </title>
      </Helmet>

      <Container>
        {/* <Stack direction='row' sx={{ marginBottom: {xs: 2, sm: 5} }} alignItems="center">
          <Button variant="contained" startIcon={<ArrowBack />} onClick={() => navigate('/dashboard/events')}>
            Back to all events
          </Button>
        </Stack> */}
        {event &&
          <>
            <Grid container maxWidth='xl' spacing={3}>
              <Grid item xs={12} sm={6} md={4} alignItems='center'>
                <Card>
                  <StyledImg src={event.images ? event.images : game?.images} alt={`${event.title} banner`} sx={{ width: '100%', height: 'auto' }} />
                </Card>
                <Box width='100%' paddingY={2}>
                  {user && ((user?.provider?.useAccountNumber && user?.accountNumber) || !user?.provider?.useAccountNumber || user?.inviteCode) &&
                    <>
                      {!(checkRegistrationCutoff(event.registrationCutoff)) &&
                        <LoadingButton loading={registrationButtonLoading} disabled={registrationButtonDisabled} variant="contained" size='large' fullWidth startIcon={<ContentPaste />} onClick={handleRegisterOpen}>
                          {registrationButtonText}
                        </LoadingButton>
                      }
                      {(checkRegistrationCutoff(event.registrationCutoff)) &&
                        <LoadingButton disabled={true} variant="contained" size='large' fullWidth startIcon={<ContentPaste />} onClick={handleRegisterOpen}>
                          Registration Closed
                        </LoadingButton>
                      }
                    </>
                  }
                  {user && !user.inviteCode && (user?.provider?.useAccountNumber && !user?.accountNumber) &&
                    <Button onClick={() => { setConnectAccountOpen(true) }} variant='contained' size='large' fullWidth sx={{ fontSize: 14 }}>
                      Connect {user?.provider?.name} account
                    </Button>
                  }
                  {!user &&
                    <Button onClick={() => { navigate(`/login?returnTo=${encodeURIComponent(pathname)}`) }} variant='contained' size='large' fullWidth>
                      Log in to register
                    </Button>
                  }
                </Box>
              </Grid>
              <Grid item sx={12} sm={6} md={8}>
                <Grid container alignItems='center'>
                  <Grid item xs={12}></Grid>
                  <Grid xs={12} marginBottom={3}>
                    <Typography variant='h2' marginBottom={2}>
                      {event.title} <Chip variant='primary' label={event.game?.category} />
                    </Typography>
                    <Typography variant='h6' lineHeight={1.7}>
                      {event.subtitle}
                    </Typography>
                    <Divider sx={{ marginY: 3 }} />
                    {/* {firstPlace &&
                      <Typography variant='h5' color='primary' mb={5}>
                        {`First Place: ${(firstPlace.type === 'cash') ? `$${firstPlace.value}` : firstPlace.type}`}
                      </Typography>
                    } */}
                    <Typography variant='body1' component={'h5'} fontSize={16} fontWeight='bold'>
                      Game
                    </Typography>
                    <Typography variant='body1' fontSize={15} marginBottom={3}>
                      {(game) &&
                        <Link variant='body1' sx={{ cursor: 'pointer' }} onClick={() => navigate(`/dashboard/games/${event.game?.id}`)}>{event.game?.title}</Link>
                      }
                      {(!game) &&
                        <>Community Selected</>
                      }
                    </Typography>
                    <Typography variant='body1' component={'h5'} fontSize={16} fontWeight='bold'>
                      Entry Fee
                    </Typography>
                    <Typography variant='body1' fontSize={15} marginBottom={3}>
                      {/* {(event.entryFee === "0") ? 'FREE' : (user && user?.provider) ? <>$<s>{event.entryFee}</s> FREE</> : <>${event.entryFee}</>} */}
                      FREE
                    </Typography>
                    {/* {firstPlace &&
                      <>
                        <Typography variant='body1' component={'h5'} fontSize={16} fontWeight='bold'>
                          Prize{(secondPlace || thirdPlace || fourthPlace) ? 's' : null}
                        </Typography>
                        <Typography variant='body1' fontSize={15}>
                          {`First Place: ${(firstPlace.type === 'cash') ? `$${firstPlace.value}` : firstPlace.type}`}
                        </Typography>
                        {secondPlace &&
                          <Typography variant='body1' fontSize={15}>
                            {`Second Place: ${(secondPlace.type === 'cash') ? `$${secondPlace.value}` : secondPlace.type}`}
                          </Typography>
                        }
                        {thirdPlace &&
                          <Typography variant='body1' fontSize={15}>
                            {`Third Place: ${(thirdPlace.type === 'cash') ? `$${thirdPlace.value}` : thirdPlace.type}`}
                          </Typography>
                        }
                        {fourthPlace &&
                          <Typography variant='body1' fontSize={15}>
                            {`Fourth Place: ${(thirdPlace.type === 'cash') ? `$${thirdPlace.value}` : thirdPlace.type}`}
                          </Typography>
                        }
                      </>
                    } */}
                    {event.streamUrl &&
                      <>
                        <Typography variant='body1' component={'h5'} fontSize={16} fontWeight='bold' marginTop={(firstPlace) ? 3 : 0}>
                          Stream URLs
                        </Typography>
                        <Typography variant='body1' fontSize={15}>
                          {event.streamUrl}
                        </Typography>
                      </>
                    }
                    <Typography variant='body1' component={'h5'} fontSize={16} fontWeight='bold' marginTop={3}>
                      Date & Time
                    </Typography>
                    <Typography variant='body1' fontSize={15}>
                      {getCleanDate(event.scheduledStart, event.scheduledEnd)}
                    </Typography>

                    <Typography variant='body1' component={'h5'} fontSize={16} fontWeight='bold' marginTop={3}>
                      Registration Cut Off
                    </Typography>
                    <Typography variant='body1' fontSize={15}>
                      {getCleanDate(event.registrationCutoff)}
                    </Typography>
                  </Grid>
                </Grid>


              </Grid>
            </Grid>
            {userIsRegistered &&
              <Grid container>
                <Grid item xs={12} dangerouslySetInnerHTML={{ __html: event.registrationMessage }}>
                </Grid>
              </Grid>
            }
            <Grid container>
              <Grid item xs={12} dangerouslySetInnerHTML={{ __html: event.description }}>
              </Grid>
            </Grid>
          </>
        }
        {event === null &&
          <Grid container justifyContent='center'>
            <Grid item>
              <CircularProgress />
            </Grid>
          </Grid>
        }
      </Container>

      <ConnectAccountDialog open={connectAccountOpen} setOpen={setConnectAccountOpen} />
      <Dialog
        open={open}
        onClose={handleRegisterClose}
        fullWidth
        maxWidth='sm'
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          {(registerStep === "provider") && (user?.provider) &&
            <Stack spacing={5} padding={5}>
              {(user?.provider?.images)
                &&
                <center>
                  <img src={(themeMode === 'light') ? user?.provider.darkLogo : user?.provider.images} style={{ maxWidth: '200px', height: 'auto' }} />
                </center>
              }
              <Typography variant='h4' textAlign='center'>
                Your costs have been covered!
              </Typography>
              <Typography variant='body1' textAlign='center'>
                Your Internet Provider has covered your costs for entering this event. Have fun!
              </Typography>
              <span dangerouslySetInnerHTML={{ __html: event.registrationMessage }} />
              <Button variant='contained' size='large' fullWidth onClick={handleRegisterClose}>
                Continue
              </Button>
            </Stack>
          }
          {(registerStep === "provider") && (!user?.provider) &&
            <Stack spacing={5} padding={5}>
              <Typography variant='h4' textAlign='center'>
                Thanks for registering!
              </Typography>
              <Typography variant='body1' textAlign='center'>
                This event will be added to your "My Events" section. Have fun!
              </Typography>
              <span dangerouslySetInnerHTML={{ __html: event.registrationMessage }} />
              <Button variant='contained' size='large' fullWidth onClick={handleRegisterClose}>
                Continue
              </Button>
            </Stack>
          }
          {(registerStep === "tournament") &&
            <Stack spacing={5} padding={5}>
              <Typography variant='h4' textAlign='center'>
                Choose Tournament
              </Typography>
              <FormControl fullWidth>
                <InputLabel id="tournament-select-label">Tournament</InputLabel>
                <Select
                  labelId="tournament-select-label"
                  id="tournament-select"
                  value={selectedTournament}
                  label="Tournament"
                  onChange={(event) => {
                    setSelectedTournament(event.target.value)
                    console.log(event.target.value);
                  }}
                >
                  {
                    tournaments.map(tournament =>
                      <MenuItem value={tournament}>{tournament}</MenuItem>
                    )
                  }
                </Select>
              </FormControl>
              <LoadingButton variant='contained' onClick={() => { register(); }} disabled={loading || !(selectedTournament)} loading={loading} fullWidth size='large'>
                Continue
              </LoadingButton>
            </Stack>
          }
          {(registerStep === "registrationQuestion") &&
            <Stack spacing={5} padding={5}>
              <Typography variant='h4' textAlign='center'>
                {registrationQuestion}
              </Typography>
              <TextField
                required
                value={registrationQuestionAnswer}
                label={registrationQuestion}
                onChange={(event) => {
                  setRegistrationQuestionAnswer(event.target.value)
                }}
              />

              <LoadingButton variant='contained' onClick={() => { register(); }} disabled={registrationQuestionAnswer.length < 1} loading={loading} fullWidth size='large'>
                Continue
              </LoadingButton>
            </Stack>
          }
          {(registerStep === "connectDiscord") &&
            <Stack spacing={5} padding={5}>
              <Typography variant='h4' textAlign='center'>
                Connect your Discord to join tournaments
              </Typography>
              <Button sx={{ paddingY: 1.5, fontSize: 17 }} variant='contained' href={getDiscordLoginLink()} fullWidth>
                <FontAwesomeIcon icon={faDiscord} style={{ marginRight: 8 }} /> Connect Discord
              </Button>
            </Stack>
          }
          {(registerStep === "reconnectDiscord") &&
            <Stack spacing={5} padding={5}>
              <Typography variant='h4' textAlign='center'>
                Reconnect your Discord to join tournaments
              </Typography>
              <Button sx={{ paddingY: 1.5, fontSize: 17 }} variant='contained' href={getDiscordLoginLink()} fullWidth>
                <FontAwesomeIcon icon={faDiscord} style={{ marginRight: 8 }} /> Connect Discord
              </Button>
            </Stack>
          }
        </DialogContent>
      </Dialog>
      <Dialog
        open={noPlanOpen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth='sm'
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          No Access
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Typography fontSize={16} pt={3}>
            You do not have access to register for <b>Fiber Gaming Network</b> events.
            <br /><br />
            Please contact <b>{user?.provider?.name}</b> for more information.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setNoPlanOpen(false)
            }}
            color='success'
            variant='contained'
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      {showSnackbar.status ? <SnackbarAlert show={showSnackbar} setShow={setShowSnackbar} message={showSnackbar.message} type={showSnackbar.type} /> : null}
    </>
  );
}

const CreditCardExpirationDate = ({ value, onChange }) => {
  const handleChange = (event) => {
    const { value: inputValue } = event.target;
    // Only allow numeric characters in the input value
    const newValue = inputValue.replace(/[^0-9]/g, "");
    // Automatically add "/" between month and year if needed
    if (newValue.length > 2) {
      const month = newValue.slice(0, 2);
      const year = newValue.slice(2);
      onChange(`${month}/${year}`);
    } else {
      onChange(newValue);
    }
  };

  return (
    <TextField
      label="Expiration Date"
      name='billing cc-exp'
      id='cc-exp'
      value={value}
      fullWidth
      onChange={handleChange}
      placeholder="MM/YY"
      autoComplete='cc-exp'
      inputProps={{
        maxLength: 5, // Maximum length of input value
        pattern: "\\d{2}/\\d{2}", // Regex pattern to enforce format
      }}
    />
  );
};

const CreditCardNumber = ({ value, onChange }) => {
  const handleChange = (event) => {
    const { value: inputValue, selectionStart } = event.target;
    const newValue = inputValue.replace(/[^0-9]/g, "");
    const formattedValue = newValue
      .match(/.{1,4}/g)
      ?.join(" ")
      .substr(0, 19);
    const unformattedValue = formattedValue?.replace(/\s/g, "");

    let newCursorPosition = selectionStart;
    if (
      selectionStart > 0 &&
      formattedValue?.charAt(selectionStart - 1) === " " &&
      inputValue.charAt(selectionStart - 1) !== " " &&
      inputValue.charAt(selectionStart) === ""
    ) {
      newCursorPosition--;
    }

    onChange(unformattedValue);
    event.target.setSelectionRange(newCursorPosition, newCursorPosition);
  };

  const formattedValue = value
    ?.match(/.{1,4}/g)
    ?.join(" ")
    .substr(0, 19);

  return (
    <TextField
      label="Credit Card Number"
      value={formattedValue}
      onChange={handleChange}
      fullWidth
      autoComplete='billing cc-number'
      name='cc-number'
      id='cc-number'
      inputProps={{
        maxLength: 19,
        pattern: "\\d{13,19}",
      }}
    />
  );
};

const CreditCardCvv = ({ value, onChange }) => {
  const handleChange = (event) => {
    const { value: inputValue } = event.target;
    const newValue = inputValue.replace(/[^0-9]/g, "");
    onChange(newValue);
  };

  return (
    <TextField
      label="CVV"
      value={value}
      onChange={handleChange}
      name='cc-csc'
      id='cc-csc'
      fullWidth
      autoComplete='billing cc-csc'
      inputProps={{
        type: "text",
        inputMode: "numeric",
        pattern: "[0-9]*",
      }}
    />
  );
};
